import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Loader, Stack, Text } from '@mantine/core'
import { useUserData } from '../api/user'
import { Header } from './Header'
import classes from './Layout.module.css'

export default function Layout() {
  const {
    data: userData,
    isPending: userDataPending,
    isError: userDataError,
  } = useUserData()

  const location = useLocation()
  const navigate = useNavigate()

  if (
    location.pathname === '/' &&
    userData &&
    userData.marinas &&
    userData.marinas.length > 0
  ) {
    navigate(`/marina/${userData.marinas[0].marina_id}`, { replace: true })
    return null
  }

  if (userDataError) {
    return (
      <Stack>
        <Text>An error during authentication, please try again later.</Text>
      </Stack>
    )
  }

  if (userDataPending) {
    return (
      <Stack align="center" justify="center">
        <Loader color="blue" />
      </Stack>
    )
  }

  return (
    <div className={classes.container}>
      <Header userData={userData} />
      <Outlet />
    </div>
  )
}
